<div class="user-card">

  <div class="user-card-top">
    <span class="top-text">Bienvenido</span>
  </div>

  <div class="user-card-circle">
    <mat-icon class="icon">person</mat-icon>
  </div>

  <div class="user-card-bottom">

    <div class="user-card-info">
        <h3>{{regularName}}</h3>
        <p>{{userName}}</p>
        <p>{{this.controlPanelService.rolItem}}</p>
    </div>

    <div class="user-card-counters">
        <div class="counter">
            <h3>{{totalLocations}}</h3>
            <p>Activos</p>
        </div>
        <div class="counter">
            <h3>{{totalGeofences}}</h3>
            <p>Geocercas</p>
        </div>
    </div>

  </div>
</div>